import React, { useState } from "react";
import { SidebarInset, SidebarProvider, useSidebar } from "../ui/sidebarNew";
import { AppSidebar } from "./AppSidebar";
import AppNavbar from "./AppNavbar";
import { Outlet } from "react-router-dom";

const LayoutContent = ({
  children,
  sidebar,
  header,
  user,
  userInfo,
  profiles,
  setModal,
  NotifModul,
  setModalNotification,
  closeCartPanel,
  cartItem,
  customTitle,
}) => {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <SidebarInset
      className={`min-h-screen bg-[oklch(98.6% 0.031 120.757)] transition-transform duration-300 ease-in-out ${
        sidebar ? (isCollapsed ? "ml-8" : "ml-0") : "ml-0"
      }`}
    >
      {/* Sticky Header */}
      {header && (
        <div className="sticky top-0 z-[50]">
          <AppNavbar
            user={user}
            userInfo={userInfo}
            profiles={profiles}
            setModal={setModal}
            NotifModul={NotifModul}
            setModalNotification={setModalNotification}
            closeCartPanel={closeCartPanel}
            cartItem={cartItem}
            customTitle={customTitle}
          />
        </div>
      )}
      <main className="p-4 bg-[#fafffa] min-h-[calc(100vh-4rem)]">
        <Outlet />
        {children}
      </main>
    </SidebarInset>
  );
};

const AppLayout = ({
  children,
  sidebar = true,
  header = true,
  user,
  userInfo,
  profiles,
  setModal,
  NotifModul,
  setModalNotification,
  closeCartPanel,
  cartItem,
  customTitle,
  goToPricing,
}) => {
  const [sideBarOpen, setSideBarOpen] = useState(() => {
    const saved = localStorage.getItem("sidebarOpen");
    return saved !== null ? JSON.parse(saved) : true;
  });

  return (
    <SidebarProvider
      onOpenChange={() => setSideBarOpen((prev) => !prev)}
      open={sideBarOpen}
    >
      {sidebar && (
        <AppSidebar
          user={user}
          userInfo={userInfo}
          profiles={profiles}
          cartItem={cartItem}
          closeCartPanel={closeCartPanel}
          setModalNotification={setModalNotification}
          setModal={setModal}
          NotifModul={NotifModul}
          goToPricing={goToPricing}
        />
      )}
      <LayoutContent
        children={children}
        sidebar={sidebar}
        header={header}
        user={user}
        profiles={profiles}
        setModal={setModal}
        NotifModul={NotifModul}
        setModalNotification={setModalNotification}
        closeCartPanel={closeCartPanel}
        cartItem={cartItem}
        customTitle={customTitle}
      />
    </SidebarProvider>
  );
};

export default AppLayout;
